import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormArray } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { Global } from 'src/app/Global';
import saveAs from 'file-saver';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchViewComponent } from 'src/app/out-of-application/search-view/search-view.component';
import { DataService } from 'src/app/Common/data.service';

@Component({
  selector: 'app-complete-report',
  templateUrl: './complete-report.component.html',
  styleUrls: ['./complete-report.component.scss']
})
export class CompleteReportComponent implements OnInit {
  // version = VERSION;
  pageID: string
  // SearchViewDialogRef: MatDialogRef<SearchViewComponent>;
  CompleteReportForm: UntypedFormGroup;
  isLoadingResults = false;
  statusList: any;
  lblheader: string = '';
  // searchParameter: any=[];
  // array: any;
  // displayedColumns = ['SNo', 'CreatedOn', 'SRNumber', 'LongDescription', 'Requester', 'OnBehalfOfRequester', 'ShortDescription', 'RequesterGPN', 'AssignmentGroup','TicketStatus'];
  // fminDate: Date;
  toDate: Date;
  // SRDataSource: MatTableDataSource<any[]>;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;

  constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService, private error: AppErrorHandler,
    injector: Injector, private status: HTTPStatus, public _dataservice: DataService, private _serviceRequestService: ServiceRequestService, private _dialog: MatDialog,) { }


  ngOnInit() {
    this.pageID = this._activeRoute.snapshot.paramMap.get('ID');
    this.CompleteReportForm = this._fb.group({
      Status: [],
      PageNumber: (this._global.pageIndex),
      PageID: (this.pageID),
      IsExport: 0,
      FilterList: this._fb.array([]),
      RecordSize: this._global.RecordSize,
      RequisitionFromDate: [],
      RequisitionToDate: [],
    });
    this.onMonitorlist();
  }


  orgValueChange(event) {
    this.CompleteReportForm.controls.RequisitionToDate.reset();
    this.toDate = new Date(event);
  }
  onMonitorlist() {
    if (this.CompleteReportForm.controls.PageID.value == 1) {
      //document.getElementById("lblheader").innerHTML = "SLA Report"
      this.lblheader = "SLA Report";
    }
    else if (this.CompleteReportForm.controls.PageID.value == 2) {
      //document.getElementById("lblheader").innerHTML = "Aging Report";
      this.lblheader = "Aging Report";
    }
    else if (this.CompleteReportForm.controls.PageID.value == 3) {
      //document.getElementById("lblheader").innerHTML = "Status Report";
      this.lblheader = "Status Report";
    }
    else if (this.CompleteReportForm.controls.PageID.value == 4) {
      //document.getElementById("lblheader").innerHTML = "Detailed Report";
      this.lblheader = "Detailed Report";
    }
    else {
      //document.getElementById("lblheader").innerHTML = "Final Report";
      this.lblheader = "Final Report";
    }
  }


  Export() {
    this.status.setHttpStatus(true);
    this._commonService.ExportToSLA(this.CompleteReportForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      if (this.CompleteReportForm.controls.PageID.value == 1) {
        saveAs(blob, 'SLA_Report.xls');
      }
      else if (this.CompleteReportForm.controls.PageID.value == 2) {
        saveAs(blob, 'Aging_Report.xls');
      }
      else if (this.CompleteReportForm.controls.PageID.value == 3) {
        saveAs(blob, 'Status_Report.xls');
      }
      else if (this.CompleteReportForm.controls.PageID.value == 4) {
        saveAs(blob, 'Detailed_Report.xls');
      }
      else {
        saveAs(blob, 'Final_Report.xls');
      }

    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

}
